export default __webpack_public_path__ + "static/media/2019 GENERAL INFORMATION SHEET (GIS).bf867606.pdf";